import styled from 'styled-components';

interface Props {
	primaryColor: string;
	fontColor: string;
	backgroundColor: string;
	backgroundImage?: string;
}

export const CustomFormStyledWrapper = styled.div<Props>`
	.oneform {
		background-color: ${props => props.backgroundColor} !important;
		background-image: ${props =>
			props.backgroundImage
				? `url('${props.backgroundImage}')`
				: 'inherit'};
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}
	span,
	p,
	input,
	select,
	div {
		color: ${props => props.fontColor} !important;
	}
	button {
		background-color: ${props => props.backgroundColor} !important;
		color: ${props => props.fontColor} !important;
		border: 1px solid ${props => props.fontColor} !important;
	}
	button:hover,
	button:focus,
	button:active {
		background-color: ${props => props.primaryColor} !important;
		color: ${props => props.fontColor} !important;
		border: 1px solid ${props => props.primaryColor} !important;
	}
	button:focus-visible {
		outline: none !important;
	}
	button[aria-label*='aceptar'],
	button[type*='submit'] {
		background-color: ${props => props.primaryColor} !important;
		color: ${props => props.fontColor} !important;
		border: 1px solid ${props => props.primaryColor} !important;

		&:hover {
			opacity: 0.8;
		}
	}
	button[aria-label*='omitir'] {
		&:hover {
			opacity: 0.8;
		}
	}
	label > div:first-child:hover {
		box-shadow: ${props => props.primaryColor} 0 0 0 1px !important;
	}
	label > div:first-child:focus-within {
		box-shadow: ${props => props.primaryColor} 0 0 0 3px !important;
	}
	label > div:focus-visible {
		outline: none;
	}
	ul {
		background-color: ${props => props.backgroundColor} !important;
		border: 1px solid ${props => props.fontColor} !important;
	}
	ul svg {
		fill: ${props => props.fontColor} !important;
	}
	ul svg:hover {
		opacity: 0.8;
	}
`;

export const CustomFormCss = ({
	primaryColor,
	fontColor,
	backgroundColor,
	backgroundImage,
}: Props): string => {
	return /*css*/ `
		/* HEADER VW */
		header {
			background-color: ${backgroundColor} !important;
		}
		header svg {
			fill: ${fontColor} !important;
		}
		header > div:nth-of-type(2) > span::before,
		header > div:nth-of-type(2) > span::after {
			background-color: ${fontColor} !important;
		}
		div[data-cy='menuLabel'] {
			color: ${fontColor} !important;
		}

		.form-controller-wrapper > div {
			background-color: ${backgroundColor} !important;
			background-image: ${backgroundImage ? `url('${backgroundImage}')` : 'inherit'};
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
		}

		/* NAVIGATION PROGRESS */
		.navigation-wrapper > div > div {
			background-color: ${backgroundColor} !important;
			color: ${fontColor} !important;
		}
		.navigation-wrapper > div:not(:last-child) > div:not(:last-child) > div:last-child{
			background-color: ${primaryColor} !important;
		}
		.navigation-wrapper * {
			color: ${fontColor} !important;
		}
		.navigation-wrapper button {
			background-color: ${primaryColor} !important;
			margin-top: 10px;
			margin-bottom: -10px;
		}
		.navigation-wrapper button:hover {
			opacity: 0.8;
		}
		.navigation-wrapper button svg {
			fill: ${fontColor} !important;
		}
		&
			.navigation-wrapper
			.inner-wrapper
			> div:nth-of-type(1)
			> div:nth-of-type(1)
			> div:nth-of-type(1) {
			background-color: #${fontColor} !important;
			opacity: 0.8;
		}
		&
			.navigation-wrapper
			.inner-wrapper
			> div:nth-of-type(1)
			> div:nth-of-type(1)
			> div:nth-of-type(2) {
			background-color: ${fontColor} !important;
		}
		.content-wrapper > div:nth-child(2) > div > div:nth-child(3) div {
			background-color: ${backgroundColor} !important;
		}
		.close-wrapper {
			background-color: transparent !important;
		}

		/* PREFIJO TELEFONO */
		.prefijo-wrapper > div > div:hover label  {
		    box-shadow: ${primaryColor} 0 0 0 1px !important;
		}

				.prefijo-wrapper > div > div label:focus-within  {
		    box-shadow: ${primaryColor} 0 0 0 3px !important;
		}

		.prefijo-wrapper > div > div:hover svg  {
		    fill: ${fontColor} !important;
		}

		/* THANK YOU */
		.thank-you-wrapper {
			background-color: ${backgroundColor} !important;
		}
		.thank-you-wrapper button {
			background-color: ${primaryColor} !important;
			color: ${fontColor} !important;
			border: 1px solid ${primaryColor} !important;
		}
		.thank-you-wrapper button:hover,
		.thank-you-wrapper button:focus,
		.thank-you-wrapper button:active {
			opacity: 0.8;
		}
		.are-you-sure-layer-content div[style] > button {
			background-color: ${primaryColor};
			border: 1px solid ${primaryColor} !important;
		}
		.are-you-sure-layer-content button {
			border: 1px solid ${backgroundColor} !important;
		}
		.are-you-sure-layer-content button:hover,
		.are-you-sure-layer-content button:focus,
		.are-you-sure-layer-content button:active {
			opacity: 0.8;
		}

		/* MAP */
		div[data-cy='layersWrapper'] > section > div > div:first-child {
			background-color: rgba(0, 0, 0, 0.6);
		}
		.styled-wrapper-suggest {
			box-shadow: ${fontColor} 0px 0px 0px 1px !important;
		}
		.lead-inpage-mapa-controller .wrapper,
		.lead-inpage-mapa-controller .close-wrapper {
			background-color: ${backgroundColor} !important;
		}
		.lead-inpage-mapa-controller button:hover,
		.lead-inpage-mapa-controller button:focus,
		.lead-inpage-mapa-controller button:active {
			background-color: ${primaryColor} !important;
			color: ${fontColor} !important;
		}
		.lead-inpage-mapa-controller .box-card-wrapper:hover {
			border: 1px solid ${primaryColor} !important;
			outline: 2px solid ${primaryColor};
			outline-offset: -2px;
		}
		.lead-inpage-mapa-controller .box-card-wrapper.active {
			border: 1px solid ${primaryColor} !important;
			outline: 2px solid ${primaryColor};
			outline-offset: -2px;
		}
		.lead-inpage-mapa-controller .box-card-wrapper {
			background-color: ${backgroundColor} !important;
		}

		.close-wrapper,
		.navigation-wrapper {
			background-color: ${backgroundColor} !important;
		}
		.close-wrapper button:hover,
		.close-wrapper button:focus,
		.close-wrapper button:active {
			background-color: ${primaryColor} !important;
			border: 1px solid ${primaryColor} !important;
		}
		.close-wrapper button:focus-visible,
		.navigation-wrapper button:focus-visible,
		.are-you-sure-layer-content button:focus-visible {
			outline: none !important;
		}

		svg.marker, svg.favourite-dealer-marker, svg.dealer-marker {
			fill: ${backgroundColor} !important;
		}
		svg.marker:hover, svg.marker.active, svg.favourite-dealer-marker.active, svg.dealer-marker.active {
			fill: ${primaryColor} !important;
		}
		svg.marker.active > path:not(:first-child), svg.favourite-dealer-marker.active > path:not(:first-child), svg.dealer-marker.active > path:not(:first-child) {
			fill: ${fontColor} !important;
		}
	`;
};
